/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planupgraded1Inputs */

const en_planupgraded1 = /** @type {(inputs: Planupgraded1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan has been upgraded!`)
};

const de_planupgraded1 = /** @type {(inputs: Planupgraded1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Plan wurde gewechselt!`)
};

/**
* | output |
* | --- |
* | "Your plan has been upgraded!" |
*
* @param {Planupgraded1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planupgraded1 = /** @type {((inputs?: Planupgraded1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planupgraded1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planupgraded1(inputs)
	return de_planupgraded1(inputs)
});
export { planupgraded1 as "planUpgraded" }